import { render, staticRenderFns } from "./EmailResend.vue?vue&type=template&id=f942bda0"
import script from "./EmailResend.vue?vue&type=script&lang=js"
export * from "./EmailResend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports